import { SOCIAL_PATTERNS } from "../../constants/leagueLockerConfig";

export type SocialPlatform =
  | "tiktok"
  | "youtube"
  | "facebook"
  | "instagram"
  | "x";

export const formatSocialLink = (
  platform: SocialPlatform,
  value: string
): string | null => {
  if (!value) return ""; // optional → empty is valid

  let url = value.trim();

  // If not a full URL, treat as handle
  if (!/^https?:\/\//i.test(url)) {
    switch (platform) {
      case "tiktok":
        url = `https://www.tiktok.com/@${url}`;
        break;
      case "youtube":
        url = `https://www.youtube.com/@${url}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/${url}`;
        break;
      case "instagram":
        url = `https://www.instagram.com/${url}`;
        break;
      case "x":
        url = `https://x.com/${url}`;
        break;
    }
  }

  // Validate
  return SOCIAL_PATTERNS[platform].test(url) ? url : null;
};
